import React from 'react'

import LogoSrc from './abihome-logo.svg'

const Logo = () => <img src={LogoSrc} alt='Abihome' />

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.js